import { Outlet, useNavigate } from 'react-router-dom'
import ErrorMsg from '../components/ErrorMsg'
import {
  INITIALIZE_APPLICATION_SETTING_ERROR,
  INITIALIZE_OFFICE_SETTINGS_ERROR_CONTENT,
} from '../constant'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useAppDispatch, useAppSelector } from '../dispatch'
import 'react-loading-skeleton/dist/skeleton.css'
import Skeleton from 'react-loading-skeleton'
import { useLayoutContext, withLayoutContext } from '../context/LayoutContext'
import DuplicateModal from '../components/Popup/DuplicateModal'
import useAppInitializer from '../hooks/useAppInitializer'
import useAwsRum from '../hooks/useAwsRum'

// let dialog: Office.AsyncResult<Office.Dialog> | null = null

function MainLayout() {
  const { state: store, dispatch: storeDispatch } = useLayoutContext()
  const initLoading = store.status === 'loading'
  const initError = store.status === 'error'
  const dispatch = useAppDispatch()
  const references = useAppSelector((state) => state.references.references)
  const navigate = useNavigate()
  useAppInitializer({
    dispatch,
    references,
    storeDispatch,
  })
  useAwsRum()
  // const templateWorker = useRef<Worker | null>(null)

  // const [processing, setProcessing] = useState(false)

  if (initError) {
    return (
      <div className="w-full h-screen p-4 flex justify-center">
        <div>
          <ErrorMsg
            title={INITIALIZE_APPLICATION_SETTING_ERROR}
            content={INITIALIZE_OFFICE_SETTINGS_ERROR_CONTENT}
            navigate={navigate}
            error={store.error}
          />
        </div>
      </div>
    )
  } else if (initLoading) {
    return (
      <div className="h-screen w-full flex flex-col overflow-hidden">
        {/* <div className="flex flex-col justify-center items-center animate-bounce">
          <div>
            <BeatLoader size={20} color="#36d7b7" />
          </div>
          <div className="font-semibold">
            Initializing Application settings...
          </div>
        </div> */}
        <div className="w-full h-1/6 max-h-12">
          <Skeleton
            containerClassName="w-full h-full block rounded-lg"
            height="100%"
            baseColor="#e5e7eb"
            highlightColor="#f3f4f6"
          />
        </div>
        <div className="w-full flex-1 p-4 mt-8">
          <Skeleton
            containerClassName="w-full h-full block rounded-lg"
            height="100%"
            baseColor="#e5e7eb"
            highlightColor="#f3f4f6"
          />
        </div>
      </div>
    )
  } else {
    return (
      <>
        <div className="flex flex-col w-full h-screen bg-[#f5f5f5] overflow-hidden relative">
          <ToastContainer
            stacked={true}
            pauseOnFocusLoss={false}
            pauseOnHover={false}
          />
          <Outlet />
          <DuplicateModal />
        </div>
      </>
    )
  }
}

export default withLayoutContext(MainLayout)
